export type {
  AddAlternateContactModalProps,
  AlternateContactValues,
  ContactFormConfig,
  ContactFormFieldConfig,
  ContactModalConfig,
} from "../../types";
export { AddAlternateContactModal } from "./AddAlternateContactModal";
